const actions = {
  SET_STATE: 'menu/SET_STATE',
  GET_DATA: 'menu/GET_DATA',
  SELECTED_OPTION: 'SELECTED_OPTION',
  REMOVE_SEARCH_BAR: 'REMOVE_SEARCH_BAR',
  STORE_LINEDATA_FROM_BTNS: 'STORE_LINEDATA_FROM_BTNS',

}

export const changeSelectedOption = payload => {
  return {
    type: actions.SELECTED_OPTION,
    payload,
  }
}

export const changeAutoSearchBar = payload => {
  return {
    type: actions.REMOVE_SEARCH_BAR,
    payload,
  }
}


export const storeLineDataForUpdateAndCreate = payload => {
  return {
    type: actions.STORE_LINEDATA_FROM_BTNS,
    payload,
  }
}

export default actions
